import { createTheme } from '@mui/material';

export const theme = createTheme({
    palette: {
        text: {
            primary: '#1E1E1E'
        },
        background: {
            default: '#dfdede',
            paper: '#dfdede'
        }
    },

    typography: {
        fontFamily: "'Montserrat', sans-serif"
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    padding: '10px',
                    background: '#ffffff',
                    boxShadow: '0px 0px 4px 0px rgba(30, 30, 30, 0.20)',
                    borderColor: '#1E1E1E',
                    borderRadius: '12px'
                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                    borderRadius: '8px'
                }
            }
        }
    }
});
